import Button from "$src/core/components/atoms/Button/Button";
import Icon from "$src/core/components/atoms/Icon";
import ScrollView from "$src/core/components/atoms/ScrollView/ScrollView";
import Text from "$src/core/components/atoms/Text/Text";
import TVFocusGuideView from "$src/core/components/atoms/TVFocusGuideView";
import type { IconName } from "$src/core/models/icon";

import $ from "./MessagePage.styles";

type Props = {
  icon: IconName;
  title: string;
  subtitle?: string;
  ctaText?: string;
  ctaIcon?: IconName;
  onPressCta?: () => void;
};

const MessagePage: React.FC<Props> = ({
  icon,
  title,
  subtitle,
  ctaText,
  ctaIcon,
  onPressCta,
}) => (
  <ScrollView contentContainerStyle={$.container} accessibilityRole="list">
    <Icon name={icon} style={$.icon} />

    <Text preset="heading3" accessibilityRole="header" style={$.title}>
      {title}
    </Text>

    {subtitle && (
      <Text preset="body" accessibilityRole="text" style={$.subtitle}>
        {subtitle}
      </Text>
    )}

    {ctaText && onPressCta && (
      <TVFocusGuideView style={$.cta} autoFocus>
        <Button
          name="message_cta"
          preset="primary"
          onPress={onPressCta}
          label={ctaText}
          icon={ctaIcon}
        />
      </TVFocusGuideView>
    )}
  </ScrollView>
);

export default MessagePage;
